import { useCallback, useEffect } from "react";
import { registerDevice } from "../services/registerDevice";
import { useSelector } from "react-redux";

export const useRegisterDevice = () => {
  const { isAuth } = useSelector((state) => state.manager);

  const sendDeviceToken = useCallback(async (payload) => {
    const { token, auth } = payload;
    await fetch(`${process.env.REACT_APP_SERVICE_URI}/deviceToken`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem("tokenMANAGER"),
      },
      body: JSON.stringify({ token, auth }),
    });
  }, []);

  useEffect(() => {
    if (isAuth) {
      registerDevice(sendDeviceToken);
    }
  }, [sendDeviceToken, isAuth]);
};
